module.exports = __webpack_public_path__ + "img/namn-david.d68e105b.svg";